<template>
  <q-page class="stretch-grid has-search no-footer">
    
    <q-collapsible id="studentSearch" class="search-box" collapse-icon="fa fa-angle-down">
      <template slot="header" class="search-box">
        <h5 style="padding: 12px 0px 12px 13px;width: 100%;">
          <q-icon name="fa fa-search" color="primary" style="padding:0 5px 3px" />Student Search
        </h5>
      </template>
      <form v-on:submit.prevent="">
        <div class="sl-row no-margin">
          <div class="sl-col-4"><q-input float-label="Agency Code" v-model="searchFields.AGENCY_CODE" /></div>
          <div class="sl-col-4"><q-input float-label="Drivers License #" v-model="searchFields['DRIVERS_LICENSE.DRIVERS_LICENSE']"/></div>
          <div class="sl-col-4"><q-input float-label="Last Name" v-model="searchFields.STUDENT_LAST_NAME"/></div>
        </div>
        <div class="sl-row no-margin">
          <div class="sl-col-4"><q-input float-label="First Name" v-model="searchFields.STUDENT_FIRST_NAME"/></div>
          <div class="sl-col-4">
            <q-field
            :error="$v.searchFields.STUDENT_DOB.$error">
              <sl-date-time
                :value="searchFields.STUDENT_DOB"
                @blur="$v.searchFields.STUDENT_DOB.$touch"
                @keyup="updateForm({ form: 'searchFields', field: 'STUDENT_DOB', value: $event.target.value })"
                float-label="Date of Birth"
                type="date" 
                width="100%"
              />
            </q-field>
          </div>   
          <div class="sl-col-4">
              <q-select
                clearable
                float-label="State"
                :options="stateOptions"
                v-model="searchFields['ADDRESSES.LK_STATE_ID']"
              />
          </div>
        </div>
        <div class="sl-row no-margin">
          <div class="sl-col-4"><q-input float-label="Phone" v-model="searchFields.STUDENT_PHONE"/></div>
          <div class="sl-col-4"><q-input float-label="Email" v-model="searchFields.STUDENT_EMAIL"/></div>
          <div class="sl-col-4">
            <q-select
              clearable
              float-label="Course"
              :options="courses"
              v-model="searchFields['SESSIONS.CLASS.COURSE.COURSE_ID']"
            />            
          </div>
        </div>
        <!-- <div class="sl-row no-margin">
          <div class="sl-col-4">
            <q-datetime
              clearable
              :value="startDate"
              :before="[{icon: 'calendar_today' }]"
              @keyup="updateForm({ form: 'searchFields', field: 'STUDENT_DOB', value: $event.target.value })"
              @clear="search()"
              type="date"
              format="MM/DD/YYYY"
              float-label="Start Date"
              popover
            />   
          </div>            
          <div class="sl-col-4">
            <q-datetime
              clearable
              :value="endDate"
              :before="[{icon: 'calendar_today' }]"
              type="date"
              format="MM/DD/YYYY"
              float-label="End Date"
              popover
              @clear="search()"
            />
          </div> 
        </div> -->

        <q-toolbar color="white" style="padding-right:60px">
          <q-toolbar-title></q-toolbar-title>
          <q-btn color="secondary" label="Clear" outline size="sm" type="reset" style="margin-right:5px" @click="fetchAndClear"/> 
          <q-btn color="primary" label="Search" size="sm" type="submit" @click="search()" />
        </q-toolbar>
      </form>
    </q-collapsible>
    <!-- content -->
    <Grid
      ref="studentGrid"
      :module="module"
      :data="studentList"
      :columns="columnOptions"
      :onLaunch="select"
      :loading="loadingData"
      :visibleColumns="visibleColumns"
      :onRequest="fetch"
      :onExport="fetch"
      :filterable="filterable">
      <template slot="col-item-active_ind" slot-scope="props">
        <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
          class="label"
          :class="{
              'green' : props.value === 'Active',
              'red' : props.value === 'Inactive'
          }">
          {{props.value}}
        </div>
      </template>
      <template slot="col-item-student_dob" slot-scope="props">
        {{ moment(props.value).format('LL') }}
      </template>
      <template v-if="$p(['ADMIN'])" slot="col-item-completed_date" slot-scope="props">
        <span v-if="props.value">{{ moment(props.value).format('LL') }}</span>
      </template>
    </Grid>
    <StudentDetailsModal v-if="open" :module="module"/>
    <!-- <q-layout-footer>
      <q-toolbar>
        <q-toolbar-title>
        </q-toolbar-title>
        <q-btn
          label="New Student"
          color="primary"
          icon="add"
          @click="addNew()">
        </q-btn>
      </q-toolbar>
    </q-layout-footer>  -->
  </q-page>
</template>

<script>
import { mapActions, mapGetters, mapState,mapMutations } from 'vuex'
import { isDate } from 'src/utils/validators'

import Grid from '../components/Shared/Grid'
import SlDateTime from 'components/Shared/DatePicker'
import StudentDetailsModal from '../components/Student/StudentDetailsModal'
const moment = require('moment')

export default {
  name: 'Students',
  components: {
    Grid,
    StudentDetailsModal,
    SlDateTime
  },
  mounted() {
    this.$store.dispatch('courses/fetchCourses')
  },
  created() {
    const columnOptions = [
      { field: 'STUDENT_FIRST_NAME', name: 'STUDENT_FIRST_NAME', label: 'First name', sortable: true, filterable: true, filter: '', type: 'string' },
      { field: 'STUDENT_LAST_NAME', name: 'STUDENT_LAST_NAME', label: 'Last Name', sortable: true, filterable: true, filter: '', type: 'string' },
      { field: 'DRIVERS_LICENSE_NUMBER', name: 'DRIVERS_LICENSE', sortColumn: 'DRIVERS_LICENSE.DRIVERS_LICENSE', label: 'Drivers License', sortable: true, filterable: true, filter: '', type: 'string' },
      { field: 'STUDENT_DOB', name: 'STUDENT_DOB', label: 'Date of Birth', sortable: true, filterable: false, filter: '', type: 'date' },
      { field: 'COMPLETED_DATE', name: 'COMPLETED_DATE', label: 'Class Date', sortable: false, filterable: false, filter: '', type: 'date' },
    ]

    // if (this.$p(['ADMIN'])) {
    //   columnOptions.push({ field: 'COMPLETED_DATE', name: 'COMPLETED_DATE', label: 'Completed Date', sortable: false, filterable: false, filter: '', type: 'date' })
    // }

    this.columnOptions = columnOptions
  },
  data () {
    return {
      moment:moment,
      filterable: true,
      module: this.$route.meta.module,
      advancedSearchOpen: false,
      visibleColumns: ['STUDENT_FIRST_NAME', 'STUDENT_LAST_NAME', 'DRIVERS_LICENSE','STUDENT_DOB', 'COMPLETED_DATE'],
      columnOptions: [],
    }
  },
  validations () {
    return {
      searchFields: {
        STUDENT_DOB: this.searchFields.STUDENT_DOB ? { isDate } : { required:false }
      }
  }
  },
  computed: {
     ...mapGetters([
      'stateOptions'
    ]),
    ...mapGetters('students', [
      'studentList'
    ]),
    ...mapState({
      open: state => state.students.studentModal.open,
      courses: s => s.students.courses
    }),
    ...mapState('students', {
      loadingData: state => state.loadingData,
      searchFields: s => s.searchFields
    }),
    minStartDate() {

    },
    maxEndDate() {
      
    },
    paginationOptions() {
      return {
        rowsNumber: (this.paginationOptions) ? this.pagination.rowsNumber : 0,
        rowsPerPage: (this.paginationOptions) ? this.pagination.rowsPerPage : 10,
        page: (this.paginationOptions) ? this.pagination.page : 1,
        descending: (this.pagination) ? this.pagination.descending : false,
        sortBy: (this.pagination) ? this.pagination.sortBy : ''
      }
    }
  },
  methods: {
    ...mapActions('students', [
      'fetch',
      'select',
      'addNew'
    ]),
    ...mapMutations('students',[
      'resetSearchFields',
      'updateForm'
    ]),
    search () {
      this.$refs.studentGrid.request({ pagination: this.$refs.studentGrid.paginationOptions })
    },
    fetchAndClear(){
      let vm = this
      vm.resetSearchFields()
      this.search()
    }
  }
}
</script>

<style lang="stylus">
</style>
